import { Component, Input, Output, EventEmitter } from '@angular/core';

export interface Card { title: string; subtitle: string; link: string; }

@Component({
  selector: 'fcp-plan-card',
  templateUrl: './plan-card.component.html',
  styleUrls: ['./plan-card.component.scss']
})
export class PlanCardComponent {

  @Input() public card: Card;

  constructor() { }

}
